/**
 * viewIRContext — the React context the interpreter hands to every node.
 *
 * Kept in its own module (no components) so both `interpreter.jsx` and any
 * component that needs the runtime services can import it without a cycle.
 *
 * Shape: `{ blueprint, ctx, emit, slotState, renderById, renderNode,
 *           renderTemplate, host, report, ui, setUi }`
 *   ctx            the render context (README §4.3)
 *   emit           (nodeId, signal, payload) → routes through connections
 *   report         (issue) → the studio's fail-closed panel; the COMPONENT
 *                  side of `onReport` (a composition cycle), beside the data
 *                  lane's unsupported selectors
 *   renderById     render another blueprint node by id (page sections)
 *   renderNode     render an INLINE node written in place
 *   renderTemplate render a node once for ONE row, under the `item` scope,
 *                  with its signals routed back to the caller (grids)
 *   ui / setUi     a HOST-OWNED selection store keyed by node id, or null —
 *                  see `useSelection` in components/ui.js and slots.js
 */
import { createContext, useContext } from 'react';

export const ViewIRContext = createContext(null);

export function useViewIR() {
  return useContext(ViewIRContext);
}
